(function () {

    'use strict';

    angular.module('app').controller('ServicesViewController', ServicesViewController);

    ServicesViewController.$inject = [
        'aborter',
        '$route',
        'toastr',
        '$timeout',
        '$location',
        '$routeParams',
        'ServicesService',
        'Carrier',
        'ClientService',
        'ConfirmationModalFactory',
        'Currency',
        'ViewChangeNotificationFactory',
        'Location',
        '$rootScope',
        'scrollToForm',
        '$uibModal',
        'AdminPermissionService',
        'PermissionHelpers'
    ];

    function ServicesViewController(
        aborter,
        $route,
        toastr,
        $timeout,
        $location,
        $routeParams,
        ServicesService,
        Carrier,
        ClientService,
        ConfirmationModalFactory,
        Currency,
        ViewChangeNotificationFactory,
        Location,
        $rootScope,
        scrollToForm,
        $uibModal,
        AdminPermissionService,
        PermissionHelpers
    ) {
        let viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'Your changes haven\'t saved yet. All changes will be lost.',
            code: 'Do you wish to continue?'
        });
        let openFormWarning = new ConfirmationModalFactory({}, {
            message: 'There are still unsaved zone/postcode based margins. These changes wont be saved.',
            code: 'Do you wish to continue'
        });
        const vm = this;
        vm.isViewMode = false;
        vm.serviceId = $route.current.params.id;
        vm.saveDetails = saveDetails;
        vm.refreshZoneTable = refreshZoneTable;
        vm.preview = preview;
        vm.back = back;
        vm.cloneMargin = cloneMargin;
        vm.service = angular.extend({
            id: vm.serviceId,
            fetching: true
        }, $rootScope.GlobalProfile.office.driverDirectSetting);

        vm.saveDetails = saveDetails;
        vm.refreshZoneTable = refreshZoneTable;
        vm.preview = preview;
        vm.back = back;
        vm.cloneMargin = cloneMargin;

        init();

        function init() {
            setIsHideRatesEngine();
            if (!vm.serviceId) {
                vm.service.fetching = false;
                vm.serviceRaw = angular.extend(vm.service);
                $timeout(() => setDriverDirectDefaults(vm.service));

            }
            else {
                vm.service.fetching = true;
                ServicesService.getClientServiceLink(vm.serviceId, function (data) {
                    angular.extend(vm.service, data);
                    vm.service.carrierProfile = angular.getObjVal(data, 'carrierProfile');
                    initDriverDirect(vm.service.serviceProfile);
                    vm.serviceRaw = angular.copy(vm.service);
                    vm.service.fetching = false;
                }, function (error) {
                    toastr.error(error.message, error.code);
                    vm.service.fetching = false;
                });
            }
        }


        function setIsHideRatesEngine() {
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                const moduleAccess = [];
                success.content.forEach(user => {
                    user.modules.forEach(module => {
                        moduleAccess.push(module.name);
                    });
                });
                vm.isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
            }, error => { }, $rootScope.GlobalProfile.id);
        }

        function setDriverDirectDefaults(service) {
            return angular.extend(service, {
                unattendedPodPicture: true,
                customerSignature: true,
                shipmentRestrictions: 'both'
            });
        }

        function initDriverDirect(selected) {
            const service = vm.service;
            if (angular.getObjVal(selected, 'carrier.id') === 'bba-driver-direct') {
                vm.service.driverDirectEnabled = true;
            }
            vm.service.disableAutoJobAssignment = !service.autoJobAssignationEnabled;
            vm.service.shipmentRestrictions = setShipmentRestrictions(service);
        }

        function setShipmentRestrictions(service) {
            if (service.shipmentTypes.length < 1) { return 'both'; }
            if (service.shipmentRestrictions || service.shipmentTypes && service.shipmentTypes.length !== 2) {
                return service.length > 0 ? service.shipmentTypes[0].name : service.shipmentTypes[0];
            }
            return 'both';
        }

        function saveDetails(...forms) {
            const invalidForm = forms.find(form => {
                if (form) {
                    form.$setSubmitted();
                    return form.$invalid;
                }
            });

            if (invalidForm) {
                scrollToForm(invalidForm.$name);
                return false;
            }
            savingStart();
        }

        function savingStart() {
            vm.savingData = true;
            const payload = cleanPayload(vm.service);
            if (vm.serviceId) {
                ServicesService.updateClientServiceLink(vm.serviceId, payload, data => {
                    toastr.success('Service updated');
                    $location.path('/margins/view/' + data.content[0].id);
                    $route.reload();
                    vm.savingData = false;
                }, error => {
                    if (error.message === 'Companies should not be empty.') {
                        error.code = 'Unable to update record';
                        vm.noCompaniesErr = error;
                    }
                    else {
                        toastr.error(error.message, 'Unable to update record');
                    }
                    vm.savingData = false;
                });
            } else {
                ServicesService.createClientServiceLink(payload, function (data) {
                    toastr.success('Service created');
                    $location.path('/margins/view/' + data.content[0].id);
                    vm.savingData = false;
                }, error => {
                    if (error.message === 'Companies should not be empty.') {
                        error.code = 'Unable to update record';
                        vm.noCompaniesErr = error;
                    }
                    else {
                        toastr.error(error.message, 'Unable to create record');
                    }
                    vm.savingData = false;
                });
            }
        }

        function cleanPayload(formData) {
            const {
                driverDirectEnabled,
                maxCarryOnWeightPerPerson,
                driverCommissionFixed,
                driverCommissionPercentage,
                smsNotification,
                emailNotification,
                callCustomer,
                unattendedPodPicture,
                customerSignature,
                requiredPackageScanning,
                keepPackageUntilRedelivery,
                p2pEnabled,
                shipmentRestrictions,
                maxJob,
                disableAutoJobAssignment,
                jobSplittingEnabled,
                pickupFeeEnabled,
                minPickupFee,
                firstMileDriverDirectConfig,
                lastMileDriverDirectConfig,
                lineHaulDriverDirectConfig,
                destinationStates,
                quoteCalculationType
            } = formData;
            return {
                serviceProfileId: angular.getObjVal(formData, 'serviceProfile.id'),
                carrierProfileId: formData.carrierProfile.id,
                name: formData.name,
                marginMinValue: formData.marginMinValue || 0,
                marginPercent: formData.marginPercent || 0,
                enabled: !!formData.enabled,
                hideQuote: !!formData.hideQuote,
                crossDockEnabled: !!formData.crossDockEnabled,
                defaultProfile: !!formData.defaultProfile,
                currency: angular.getObjVal(formData, 'serviceProfile.currency') || 'AUD',
                zoneMargins: {
                    enabled: angular.getObjVal(formData, 'zoneMargins.enabled'),
                    regions: getZoneBasedMarginsData(formData)
                },
                postcodeMargins: {
                    enabled: angular.getObjVal(formData, 'postcodeMargins.enabled'),
                    regions: getPostcodeBasedMarginsData(formData)
                },
                postcodeFilters: {
                    enabled: angular.getObjVal(formData, 'postcodeFilters.enabled'),
                    regions: getFilterPostcodeData(formData)
                },
                zoneFilters: {
                    enabled: angular.getObjVal(formData, 'zoneFilters.enabled'),
                    regions: getFilterZoneData(formData)
                },
                companyOffices: getOfficesData(formData),
                driverDirectEnabled,
                maxCarryOnWeightPerPerson,
                driverCommissionFixed,
                driverCommissionPercentage,
                smsNotification,
                emailNotification,
                callCustomer,
                unattendedPodPicture,
                customerSignature,
                requiredPackageScanning,
                keepPackageUntilRedelivery,
                destinationStates,
                quoteCalculationType,
                returnPackageToDepot: !keepPackageUntilRedelivery,
                p2pEnabled,
                maxJob,
                shipmentType: shipmentRestrictions === 'both' ? '' : shipmentRestrictions,
                autoJobAssignationEnabled: !disableAutoJobAssignment,
                jobSplittingEnabled,
                pickupFeeEnabled: pickupFeeEnabled || false,
                minPickupFee: minPickupFee || 0,
                firstMileDriverDirectConfig: formData.firstMileDriverDirectConfig || { enabled: false },
                lastMileDriverDirectConfig: formData.lastMileDriverDirectConfig || { enabled: false },
                lineHaulDriverDirectConfig: formData.lineHaulDriverDirectConfig || { enabled: false },
                autoAssignEnterprise: formData.autoAssignEnterprise,
                autoAssignLite: formData.autoAssignLite,
                autoAssignPlatinum: formData.autoAssignPlatinum,

                autoAssignPlatinumPlus: formData.autoAssignPlatinumPlus || false,
                autoAssignPlatinumGalaxy: formData.autoAssignPlatinumGalaxy || false,
                autoAssignHouseAccount: formData.autoAssignHouseAccount || false,

                directCarrierBillsServiceEnabled: formData.directCarrierBillsServiceEnabled
            };
        }

        function getOfficesData(data) {
            if (data.companiesRaw) {
                return data.companiesRaw;
            }
            return data.companyOffices ? data.companyOffices.map(val => {
                let offices = val.offices.value ? val.offices.value : val.offices;
                return {
                    id: val.id.toString(),
                    offices: offices ? offices.map(office => {
                        return office.id;
                    }) : []
                }
            }) : [];
        }

        function getZoneBasedMarginsData(data) {
            if (data.regionsRaw) {
                return data.regionsRaw;
            }
            return angular.getObjVal(data, 'zoneMargins.regions.length') ? data.zoneMargins.regions.map(value => {
                return {
                    zoneFrom: value.zoneFrom.value ? value.zoneFrom.value.id : value.zoneFrom.id,
                    zoneTo: value.zoneTo.value ? value.zoneTo.value.id : value.zoneTo.id,
                    marginFixed: angular.getObjVal(value, 'marginFixed') || 0,
                    marginPercent: angular.getObjVal(value, 'marginPercent') || 0
                }
            }) : [];
        }

        function getPostcodeBasedMarginsData(data) {
            if (data.postcodesRaw) {
                return data.postcodesRaw
            }
            return angular.getObjVal(data, 'postcodeMargins.regions.lenght') ? data.postcodeMargins.regions.map(value => {
                return {
                    postcodeRangeStart: value.postcodeRangeStart.value ? value.postcodeRangeStart.value.code : value.postcodeRangeStart.code,
                    postcodeRangeEnd: value.postcodeRangeEnd.value ? value.postcodeRangeEnd.value.code : value.postcodeRangeEnd.code,
                    country: value.getObjVal(value, 'countryObj.code'),
                    marginFixed: angular.getObjVal(value, 'marginFixed') || 0,
                    marginPercent: angular.getObjVal(value, 'marginPercent') || 0
                }
            }) : [];
        }

        function getFilterZoneData(data) {
            if (data.zoneFiltersRaw) {
                return data.zoneFiltersRaw
            }
            return angular.getObjVal(data, 'zoneFilters.regions.lenght') ? data.zoneFilters.regions.map(value => {
                return {
                    zoneFrom: value.zoneFrom.value ? value.zoneFrom.value.code : value.zoneFrom.code,
                    zoneTo: value.zoneTo.value ? value.zoneTo.value.code : value.zoneTo.code
                }
            }) : [];
        }

        function getFilterPostcodeData(data) {

            if (data.postcodeFiltersRaw) {
                return data.postcodeFiltersRaw
            }
            return angular.getObjVal(data, 'postcodeFilters.regions.lenght') ? data.postcodeFilters.regions.map(value => {
                return {
                    postcodeFrom: value.postcodeFrom.value ? value.postcodeFrom.value.code : value.postcodeFrom.code,
                    postcodeTo: value.postcodeTo.value ? value.postcodeTo.value.code : value.postcodeTo.code
                }
            }) : [];
        }

        function refreshZoneTable() {
            vm.service.serviceProfile = null;
            vm.clearMarginsTable = true;
        }

        function back() {
            if (vm.serviceId) {
                if (!angular.equals(cleanPayload(vm.service), cleanPayload(vm.serviceRaw))) {
                    viewConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            $location.path('/margins');
                        }
                    });
                } else {
                    $location.path('/margins');
                }
            }
            else {
                if (vm.service) {
                    viewConfirmation.getInstance().result.then(function (cond) {
                        if (cond) {
                            $location.path('/margins');
                        }
                    });
                }
                else {
                    $location.path('/margins');
                }
            }
        }

        function preview() {
            $location.path(`/margins/view/${vm.serviceId}/preview`);
        }

        function cloneMargin() {
            $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/services/modal/clone-margin-modal.html',
                controller: 'CloneMarginModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    marginData: () => {
                        return vm.service;
                    }
                }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/services/ServicesViewController.js